// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import { useMemo } from "react"
import {
  selectProductNumbers,
  useMemberDocumentsQuery,
} from "@/store/apis/linkApi"
import { useMessagesDataQuery } from "@/store/apis/matrixApi"
import { selectDocumentsRead, selectMessagesRead } from "@/store/ui/ui.slice"
import { useSelector } from "react-redux"
import {
  selectHasMemberId,
  selectIsAdmin,
  selectMemberId,
} from "@/store/member/member.slice"

export function useInbox() {
  const documentsRead = useSelector(selectDocumentsRead)
  const messagesRead = useSelector(selectMessagesRead)
  const productIds = useSelector(selectProductNumbers)

  const isAdmin = useSelector(selectIsAdmin)
  const hasMemberId = useSelector(selectHasMemberId)
  const memberId = useSelector(selectMemberId)

  const sendMemberId = isAdmin && !hasMemberId ? { memberId } : {}

  const params = {
    ids: productIds,
    ...sendMemberId,
  }

  const { isFetching: documentsIsFetching, data: documentsData } =
    useMemberDocumentsQuery()

  const { isFetching: isFetchingMessages, data: messagesData } =
    useMessagesDataQuery(params)

  const documentsDataFiltered = useMemo(() => {
    return (
      (documentsData?.resource?.documents ?? [])
        // remove any docs with eStmt in description
        .filter((item) => !/eStmt Email/i.test(item?.description ?? ""))
        // remove GESB from the description to map
        // correctly to new plan names
        .map((item) =>
          /^GESB /.test(item?.description)
            ? {
                ...item,
                description: item.description.replace(/^GESB /, ""),
              }
            : item
        )
    )
  }, [documentsData])

  return {
    isFetching: documentsIsFetching || isFetchingMessages,
    documentsData: documentsDataFiltered,
    documentsRead,
    messagesData: messagesData || [],
    messagesRead,
  }
}

export function useInboxUnread() {
  const inboxData = useInbox()

  const { documentsData, documentsRead, messagesData, messagesRead } = inboxData

  // const isAdmin = false // switch to show notification
  const isAdmin = useSelector(selectIsAdmin)

  const allDocIds = [
    ...documentsData.map((doc) => {
      return doc.documentId
    }),
  ]

  const allMessageIds = [
    ...messagesData.map((msg) => {
      return msg.assetId
    }),
  ]

  const unreadDocs = allDocIds.filter((id) => !documentsRead.includes(id))

  const unreadMessages = allMessageIds.filter(
    (id) => !messagesRead.includes(id)
  )

  const unreadTotal = !isAdmin && [...unreadDocs, ...unreadMessages].length

  return {
    unreadDocs,
    unreadMessages,
    unreadTotal,
    ...inboxData,
  }
}
